export const enLang = {
  languageKey: 'en',
  translates: {
    IDENTITY_DOCUMENT_TYPE: 'Document Type',
    IDENTITY_DOCUMENT_DNI: 'DNI',
    IDENTITY_DOCUMENT_NIE: 'NIE',
    IDENTITY_DOCUMENT_CIF: 'CIF',
    IDENTITY_DOCUMENT_SPANISH_PASSPORT: 'Spanish Passport',
    IDENTITY_DOCUMENT_FOREIGN_PASSPORT: 'Foreign Passport',
    IDENTITY_DOCUMENT_OTHER: 'Other',
    IDENTITY_DOCUMENT_NOT_AVAILABLE: 'Not available',
    IDENTITY_DOCUMENT_NUMBER: 'Identity number',
    nif: 'NIF/NIE/Passport/CIF',
  },
};
